import InfoBeneficiaryStep1DemoFormComponent from '../../components/info-beneficiary/InfoBeneficiaryStep1DemoFormComponent';
import InfoBeneficiaryStep1FormComponent from '../../components/info-beneficiary/InfoBeneficiaryStep1FormComponent';
import useAppState from '../../context/AppContext';

export default function InfoBeneficiaryStep1Bloc() {
  const {
    state: { isDemo},
  } = useAppState();

      return (
        <div className="">
          <div className="">
            {isDemo&&<InfoBeneficiaryStep1DemoFormComponent />}
            {!isDemo&&<InfoBeneficiaryStep1FormComponent />}
          </div>
        </div>
      )
}